module.exports = __webpack_public_path__ + "img/丰富品牌商.fd27d96a.png";